<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="priceLists"
      class="elevation-1"
      :loading="isLoading"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="PriceList-button-new"
            @click="$router.push({
              name: 'quotes-EditPriceList'
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
          <div class="text-h5 ml-2">
            Price List
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons :editLink="{
            name: 'quotes-EditPriceList',
            query: {id: item.id}
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListPriceList',
  module: 'PriceList',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('priceLists', ['priceLists']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('supplierId'),
          value: 'supplier.name',
        },
        {
          text: 'Item Name',
          value: 'name',
        },
        {
          text: this.$$t('price'),
          value: 'price',
        },
        {
          text: this.$$t('markup'),
          value: 'markup',
        },
        {
          text: this.$$t('costToCustomer'),
          value: 'costToCustomer',
        },
        {
          text: this.$$t('grossProfit'),
          value: 'grossProfit',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_priceLists();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('priceLists', ['LOAD_priceLists', 'DELETE_priceList']),
    /** Delete PriceList from the collection
     */
    async remove(priceList) {
      this.isLoading = true;
      await this.DELETE_priceList(priceList.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# PriceList example

'''js
<PriceList />
'''
</docs>
